import christine from "../assets/christine.jpg";

export function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[92vh] flex items-center overflow-hidden pt-24 pb-16 bg-sand-50"
    >
      <div
        className="absolute inset-0 -z-10 opacity-[0.04]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)",
          backgroundSize: "32px 32px",
          color: "var(--color-stone-900)",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-[1.05fr_1fr] gap-10 lg:gap-16 items-center w-full">
        <div className="animate-fade-up order-2 md:order-1" style={{ animationDelay: "0.1s", opacity: 0 }}>
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-px bg-sage-700" />
            <span className="text-sage-700 text-[11px] tracking-[0.35em] uppercase font-medium">
              Pädagogische Kinesiologie
            </span>
          </div>

          <h1 className="font-display text-[2.75rem] md:text-6xl lg:text-7xl text-stone-900 leading-[1.04] mb-7 tracking-tight font-semibold">
            Potential
            <br />
            entfalten,
            <br />
            <span className="text-sage-700">Blockaden lösen.</span>
          </h1>

          <p className="text-stone-700 text-base md:text-lg leading-relaxed mb-10 max-w-md font-light">
            Kinesiologische Begleitung für Lernen, Gesundheit und innere Balance –
            bei dir zuhause oder bei mir in Waldburg.
          </p>

          <div className="flex items-center gap-6 flex-wrap">
            <a
              href="#kontakt"
              className="inline-flex items-center gap-2.5 bg-stone-900 hover:bg-sage-700 text-sand-50 px-7 py-3.5 transition-colors duration-300 font-medium text-sm"
            >
              Termin vereinbaren
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="#behandlungen"
              className="group inline-flex items-center gap-2 text-stone-800 hover:text-sage-700 transition-colors duration-200 font-medium text-sm border-b border-stone-800 hover:border-sage-700 pb-1"
            >
              Angebot ansehen
            </a>
          </div>

          <div className="mt-14 pt-8 border-t border-stone-800/10 flex flex-wrap gap-x-8 gap-y-3 max-w-md">
            {["Lernen & Gesundheit", "Blockaden lösen", "Stress abbauen"].map((t) => (
              <div key={t} className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-terra-500" />
                <span className="text-sm text-stone-700 font-light">{t}</span>
              </div>
            ))}
          </div>
        </div>

        <div
          className="relative order-1 md:order-2 animate-fade-in"
          style={{ animationDelay: "0.3s", opacity: 0 }}
        >
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden bg-sand-200">
            <img
              src={christine}
              alt="Christine Pfeifle-Rauch"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-stone-900/5 rounded-[2rem]" />
          </div>

          <div className="absolute -bottom-5 -left-5 md:-left-8 bg-sand-50 px-5 py-4 max-w-[210px] rounded-2xl shadow-[0_8px_30px_-12px_rgba(20,50,59,0.22)]">
            <p className="text-[10px] text-sage-700 tracking-[0.3em] uppercase mb-1 font-medium">Christine</p>
            <p className="font-display text-lg text-stone-900 font-semibold leading-tight">Pfeifle-Rauch</p>
            <p className="text-xs text-stone-700/70 mt-1">Päd. Kinesiologin · Lehrerin (GS)</p>
          </div>

        </div>
      </div>
    </section>
  );
}
